import React, { useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import { Label } from "reactstrap";
import cx from "classnames";

import { getHomepage } from "utils";
import { useFetchScrivitoImages, useTranslate } from "hooks";
import { Select } from "components/Select/Select";
import NiceModal from "@ebay/nice-modal-react";
import { ProductImageModal } from "components/_Modals/ProductImageModal";
import { Icon } from "components";
import s from "../ProductConfiguratorComponent.module.scss";

export const ImageDropdown = Scrivito.connect(({ images = [] }) => {
  const translate = useTranslate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const scrivitoImages = useFetchScrivitoImages(images);

  const handleSelectImage = (e) => {
    setSelectedImageIndex(e.index);
  };

  const productListPage = getHomepage()?.get("productListPage");
  const defaultImage = productListPage?.get("defaultProductImage");

  if (!scrivitoImages) {
    return;
  }

  const currentImage = useMemo(
    () => scrivitoImages[selectedImageIndex] || defaultImage,
    [defaultImage, scrivitoImages, selectedImageIndex],
  );

  const options = useMemo(
    () =>
      images &&
      images.map((image, index) => ({
        label: image.text,
        value: image.pimId + index,
        index,
      })),
    [images],
  );

  const selectedOption = options[selectedImageIndex];

  return (
    <div className={cx("m-0 h-100 w-100", s.cardContainer)}>
      <Label className="py-2 mb-0 h5 fs-md">
        {translate("PRODUCT_CONFIGURATOR_IMAGE")}
      </Label>
      <Select
        options={options}
        onChange={handleSelectImage}
        value={selectedOption}
        name="imageSelect"
        testId="image-select"
        className="font-md"
        menuPlacement={"auto"}
      />
      <div className="position-relative object-fit-contain m-3 p-3 text-center">
        <Scrivito.ImageTag
          className={cx("img-fluid", s.cardTabsImage)}
          content={scrivitoImages[selectedImageIndex] || defaultImage}
        />
        {currentImage && (
          <Icon
            iconName="arrows-maximize-regular"
            className={cx("position-absolute top-0 end-0", s.icon)}
            prefix="trox"
            data-testid="technical-design-header-arrows-maximize-icon"
            onClick={() => {
              NiceModal.show(ProductImageModal, {
                image: currentImage,
              });
            }}
          />
        )}
      </div>
    </div>
  );
});
